<template>
  <v-container style="max-width: 700px; padding-top: 2rem">
    <h1 class="text-h4 font-weight-bold mb-6">Abonnement</h1>

    <v-progress-circular
      v-if="sub.loading"
      indeterminate
      color="primary"
      class="d-block mx-auto my-8"
    />

    <template v-else>
      <!-- Active Subscription -->
      <v-card v-if="sub.isActive" color="surface" class="pa-6 mb-6">
        <div class="d-flex align-center mb-4">
          <v-icon color="primary" size="32" class="mr-3">mdi-crown</v-icon>
          <div>
            <h2 class="text-h5 font-weight-bold">Premium</h2>
            <p class="text-body-2 text-grey">
              {{ sub.isCanceling ? "Udløber" : "Fornyes" }}
              {{ sub.periodEnd }}
            </p>
          </div>
        </div>

        <v-divider class="my-4" />

        <div class="d-flex ga-3">
          <v-btn variant="outlined" @click="sub.openPortal()">
            <v-icon start>mdi-credit-card-outline</v-icon>
            Administrer betaling
          </v-btn>
          <v-btn
            v-if="!sub.isCanceling"
            variant="text"
            color="error"
            @click="showCancel = true"
          >
            Opsig abonnement
          </v-btn>
          <v-chip v-else color="warning" variant="tonal">
            Opsagt — aktiv til {{ sub.periodEnd }}
          </v-chip>
        </div>
      </v-card>

      <!-- No Subscription -->
      <v-card v-else color="surface-variant" variant="flat" class="pa-8 text-center">
        <v-icon size="48" color="grey" class="mb-4">mdi-crown-outline</v-icon>
        <h2 class="text-h5 font-weight-bold mb-2">Ingen aktivt abonnement</h2>
        <p class="text-body-2 text-grey mb-4">
          Opgrader til Premium for at få fuld adgang.
        </p>
        <v-btn color="primary" size="large" to="/pricing">Se priser</v-btn>
      </v-card>
    </template>

    <!-- Cancel Dialog -->
    <v-dialog v-model="showCancel" max-width="400">
      <v-card class="pa-6">
        <h3 class="text-h6 mb-4">Opsig abonnement?</h3>
        <p class="text-body-2 mb-2">
          Du beholder adgang indtil {{ sub.periodEnd }}.
        </p>
        <p class="text-body-2 text-grey mb-4">
          Du kan altid genaktivere dit abonnement.
        </p>
        <div class="d-flex justify-end ga-2">
          <v-btn variant="text" @click="showCancel = false">Fortryd</v-btn>
          <v-btn color="error" :loading="canceling" @click="handleCancel">
            Opsig
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useSubscriptionStore } from "../stores/subscription";

const sub = useSubscriptionStore();
const showCancel = ref(false);
const canceling = ref(false);

async function handleCancel() {
  canceling.value = true;
  try {
    await sub.cancel();
    showCancel.value = false;
  } finally {
    canceling.value = false;
  }
}

onMounted(() => {
  sub.fetchStatus();
});
</script>
